import React from 'react';
import { ITableHeader } from './table.model';
import cx from 'classnames';
import styles from './table.module.scss';

const TableHeader = (props: ITableHeader) => {
  const { children, className, sticky } = props;

  const classNames = cx(styles.tableHeader, className);

  return <thead className={classNames}>{children}</thead>;
};

export default TableHeader;

TableHeader.displayName = 'Table.Header';
